import * as v from 'valibot';

export const availableAccessorialCodesApiSchema = v.record(v.string(), v.string());

export const availableAccessorialCodeOptionSchema = v.object({
  id: v.string(),
  label: v.string(),
  value: v.string(),
});

export type AvailableAccessorialCodesApi = v.InferOutput<typeof availableAccessorialCodesApiSchema>;
export type AvailableAccessorialCodeOption = v.InferOutput<typeof availableAccessorialCodeOptionSchema>;

export type AvailableAccessorialCodes = {
  list: AvailableAccessorialCodeOption[];
  map: Record<string, AvailableAccessorialCodeOption>;
};
